import { __extends } from "tslib";
import { AsyncOperator } from "./AsyncOperator";
import * as async from "./AsyncOperator";
import { Evaluation } from "./Evaluation";
var Operator = (function () {
    function Operator() {
    }
    Operator.prototype.or = function (rule) {
        if (rule instanceof AsyncOperator) {
            return new async.OrOperator(this, rule);
        }
        return new OrOperator(this, rule);
    };
    Operator.prototype.orNot = function (rule) {
        if (rule instanceof AsyncOperator) {
            return new async.OrOperator(this, rule.notThis());
        }
        return new OrOperator(this, rule.notThis());
    };
    Operator.prototype.xor = function (rule) {
        if (rule instanceof AsyncOperator) {
            return new async.XorOperator(this, rule.notThis());
        }
        return new XorOperator(this, rule.notThis());
    };
    Operator.prototype.and = function (rule) {
        if (rule instanceof AsyncOperator) {
            return new async.AndOperator(this, rule);
        }
        return new AndOperator(this, rule);
    };
    Operator.prototype.andNot = function (rule) {
        if (rule instanceof AsyncOperator) {
            return new async.AndOperator(this, rule.notThis());
        }
        return new AndOperator(this, rule.notThis());
    };
    Operator.prototype.notThis = function () {
        return new NotOperator(this);
    };
    Operator.prototype.with = function (ctx) {
        return new WithContextOperator(this, ctx);
    };
    Operator.prototype.runWith = function (ctx) {
        var _this = this;
        return Evaluation.evaluateTree(function (evaluation) {
            return _this.evaluate(ctx, evaluation);
        });
    };
    return Operator;
}());
export { Operator };
var WithContextOperator = (function (_super) {
    __extends(WithContextOperator, _super);
    function WithContextOperator(value, ctx) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.ctx = ctx;
        return _this;
    }
    WithContextOperator.prototype.evaluate = function (_, evaluation) {
        return this.value.evaluate(this.ctx, evaluation);
    };
    return WithContextOperator;
}(Operator));
export { WithContextOperator };
var OrOperator = (function (_super) {
    __extends(OrOperator, _super);
    function OrOperator(left, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    OrOperator.prototype.evaluate = function (ctx, evaluation) {
        if (this.left.evaluate(ctx, evaluation)) {
            return true;
        }
        return this.right.evaluate(ctx, evaluation);
    };
    return OrOperator;
}(Operator));
export { OrOperator };
var XorOperator = (function (_super) {
    __extends(XorOperator, _super);
    function XorOperator(left, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    XorOperator.prototype.evaluate = function (ctx, evaluation) {
        return (this.left.evaluate(ctx, evaluation) ===
            this.right.evaluate(ctx, evaluation));
    };
    return XorOperator;
}(Operator));
export { XorOperator };
var AndOperator = (function (_super) {
    __extends(AndOperator, _super);
    function AndOperator(left, right) {
        var _this = _super.call(this) || this;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    AndOperator.prototype.evaluate = function (ctx, evaluation) {
        if (this.left.evaluate(ctx, evaluation)) {
            return this.right.evaluate(ctx, evaluation);
        }
        return false;
    };
    return AndOperator;
}(Operator));
export { AndOperator };
var NotOperator = (function (_super) {
    __extends(NotOperator, _super);
    function NotOperator(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    NotOperator.prototype.evaluate = function (ctx, evaluation) {
        return !this.value.evaluate(ctx, evaluation);
    };
    return NotOperator;
}(Operator));
export { NotOperator };
